export default "__VITE_ASSET__eRuOS$Ux__"